export class Consts {
    public static Storage = {
        Settings: 'settings',
        Routes: 'routes',
        RegionalApiEndpoint: 'regionalApiEndpoint'
    };
}